export const LANDING = '/';
export const HOME = '/home';
export const  RETREAT_HOSTS = '/retreatHosts';
export const  SIGNUP = '/signup';